import React, { useState } from "react";
import { isArray } from "lodash";
import { ImagePath } from "../../../../assets/ImagePath";
import { formatDateTimeWithDateTimeFormat } from "../../../../utils/moment";
import { getDarkenHexColor } from "../../../../utils/Helpers";


const MapSideDrawer = ({ geoPointsValidaterArray, handleOnClickAlert }) => {
	const [sideBarShow, setSideBarShow] = useState(true);

	return (
		<>
			{sideBarShow ?
				<div className="bg-[#f9f9f9] max-w-[310px] p-[12px] relative top-0 h-full z-10 transition-transform duration-300 ease-in-out">
					<div
						onClick={() => setSideBarShow(!sideBarShow)}
						className="absolute right-[-78px] cursor-pointer z-10 top-[18px] border-l border-[#ddd] bg-[#f9f9f9] 
						text-black text-size-14 font-medium flex items-center gap-[7px] p-[6px_9px] rounded-r-[18px]">
						<img src={ImagePath.alert} alt="alert" className="h-4 w-4" />
						Alerts
					</div>
					<div className="flex items-center justify-between pb-3">
						<h3 className="text-black text-size-14 font-medium m-0">Alerts</h3>
						<img src={ImagePath.filter} alt="filter" className="w-5" />
					</div>
					<div className="h-full overflow-auto pb-14">
						{
							isArray(geoPointsValidaterArray) && geoPointsValidaterArray.length > 0 ?
								geoPointsValidaterArray.map((item, i) => {
									return (
										<div
											key={i}
											onClick={() => handleOnClickAlert(item)}
											className="p-3 rounded-[14px] bg-[#fffae9] mt-[8px] hover:shadow-lg cursor-pointer"
											style={{
												backgroundColor: item.rowOptions?.backgroundColor || "#fff",
												border: `1px solid transparent`,
												...(item.rowOptions?.backgroundColor && {
													'--hover-border-color': getDarkenHexColor(item.rowOptions?.backgroundColor, 30)
												}),
											}}
											onMouseEnter={e => {
												if (item.rowOptions?.backgroundColor) {
													e.currentTarget.style.borderColor = getDarkenHexColor(item.rowOptions?.backgroundColor, 30);
												}
											}}
											onMouseLeave={e => {
												e.currentTarget.style.borderColor = 'transparent';
											}}
										>

											{item.rowOptions?.cellTitle && (
												<div className="flex items-start justify-between">
													<h6 className="text-[#252F4A] text-[14px] font-bold leading-[24px] m-0 capitalize">
														{item.rowOptions?.cellTitle}
													</h6>
													{
														item.rowOptions?.backgroundColor && <span
															className="inline-block w-3 h-3 rounded-full ml-1 mt-1"
															style={{ backgroundColor: getDarkenHexColor(item.rowOptions?.backgroundColor, 30) }}>
														</span>
													}
												</div>
											)}

											{Object.entries(item?.showInPreviewFields)
												.map(([key, value]) => (
													<div key={key} className="flex items-center justify-between">
														<p className="text-[#6A6A6A] text-[13px] font-medium m-0">
															{key}
														</p>
														<p className="text-[#252F4A] text-[13px] font-semibold m-0">
															{key === "Created On" || key === "Last Update"
																? formatDateTimeWithDateTimeFormat(value)
																: value || "-"}
														</p>
													</div>
												))}
										</div>
									)
								})
								:
								(
									<div className="flex flex-col items-center justify-center h-full text-center text-[#888] pt-10">
										<p className="text-size-14 font-medium">No alerts available</p>
									</div>
								)
						}
					</div>
				</div>
				:
				<div
					onClick={() => setSideBarShow(!sideBarShow)}
					className="absolute left-0 cursor-pointer z-10 top-[18px] border-l border-[#ddd] bg-[#f9f9f9] text-black text-size-14
					font-medium flex items-center gap-[7px] p-[6px_9px] rounded-r-[18px]"
				>
					<img src={ImagePath.alert} alt="alert" className="h-4 w-4" />Alerts
				</div>
			}
		</>
	)
};

export default MapSideDrawer;
